interface ToolCardDescriptionProps {
  description: string;
}

const ToolCardDescription = ({ description }: ToolCardDescriptionProps) => {
  return (
    <p className="text-sm text-gray-600 line-clamp-2 mt-2 group-hover:text-gray-700 transition-colors duration-300">
      {description}
    </p>
  );
};

export default ToolCardDescription;